import React, {Component} from 'react';

import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  ContainerDivs,
  SignupForm,
  // Link,
  // LinkIcon,
  GetStartedInput,
  AboutBanner
} from '../../components'
import Styles from './Signup.css'
import container from '../../helpers/container'

@CSSModules(Styles)
export default class Signup extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'Sign up'
    const description = 'Sign up for email updates from Fossil Free Funds.'
    const url = config.domain + config.routes.signup

    return (
      <div>
        {container.helmet(title, description, url)}
        <div styleName='page'>
          <ContainerDivs>
            <div styleName='title'>
              Sign up for email updates
            </div>

            <div styleName='form-wrap'>
              <SignupForm />
            </div>

            <AboutBanner/>

          </ContainerDivs>

          <GetStartedInput/>

        </div>
      </div>
    )
  }
}